import type { Zone } from 'homey-api';

export class ZoneUtils {
  static getPathForZone(zones: Record<string, Zone>, zone: Zone): string[] {
    const path: string[] = [];
    let currentZone: Zone = zone;

    while (currentZone.parent != null) {
      path.unshift(currentZone.parent);
      currentZone = zones[currentZone.parent];
    }

    return path;
  }
}
